import React from 'react'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'

const FavoriteIconComponent = ({
    addGalleryImgUser,
    item,
    galleryImagesUser,
    activeAddButton,
}) => {
    const imageId = item?.img || item?.picture?.img || ''
    const active = activeAddButton(imageId, galleryImagesUser, 'img') === imageId

    const handleClick = (event) => {
        event.stopPropagation()

        if (typeof addGalleryImgUser === 'function') {
            addGalleryImgUser(item)
        }
    }

    return (
        <button
            type="button"
            className={`favoriteIcon ${active ? 'active' : ''}`}
            onClick={handleClick}
            aria-label={active ? 'Удалить из избранного' : 'Добавить в избранное'}
        >
            {active ? <FavoriteIcon /> : <FavoriteBorderIcon />}
        </button>
    )
}

export default FavoriteIconComponent